import * as React from 'react'
import { DataList, IDataListInstanceProps, IDataListProps } from 'uxp/components'

const MemorizedList: React.ForwardRefExoticComponent<IDataListProps & React.RefAttributes<IDataListInstanceProps>> = React.forwardRef((props, ref) => {
    return <DataList {...props} ref={ref} />
})

export default React.memo(MemorizedList)